type GalleryPhoto = {
  src: string;
  alt: { ko: string; en: string };
  source?: string;
  objectPosition?: string;
};

const automationWorldSource =
  'https://www.linkedin.com/posts/deeplyinc_aw2026-automationworld-deeply-activity-7437404360071995392-9gHB';
const anniversarySource =
  'https://www.linkedin.com/feed/update/urn:li:activity:7480068108133482497/';
const fieldVisitSource =
  'https://www.linkedin.com/feed/update/urn:li:activity:7508410816598167552/';

const legacyPhoto = (filename: string): GalleryPhoto => ({
  src: `/images/apps/about/${filename}`,
  alt: { ko: '', en: '' },
});

// Corporate photographs published by Deeply; approval: marketing Slack,
// 2026-09-30, thread 1789956183.734849. Keep a local copy rather than
// depending on LinkedIn CDN URLs in the public gallery.
export const ABOUT_GALLERY_TOP: readonly GalleryPhoto[] = [
  legacyPhoto('sec_02_img_02.jpg'),
  {
    src: '/images/apps/about/aw-2026-booth.jpg',
    alt: {
      ko: 'Automation World 2026 디플리 부스에서 방문객에게 솔루션을 소개하는 모습',
      en: 'Deeply presenting its solutions to visitors at Automation World 2026',
    },
    source: automationWorldSource,
  },
  {
    src: '/images/apps/about/team-anniversary-2026.jpg',
    alt: {
      ko: '새 사무실에서 창립기념일을 함께 축하하는 디플리 팀',
      en: 'The Deeply team celebrating its anniversary at the new office',
    },
    source: anniversarySource,
  },
  {
    src: '/images/apps/about/field-team-inspection-2026.jpg',
    alt: {
      ko: '산업 현장에서 담당자와 함께 설비를 점검하는 디플리 팀원',
      en: 'A Deeply team member inspecting equipment with on-site personnel',
    },
    source: fieldVisitSource,
    objectPosition: '50% 40%',
  },
  {
    src: '/images/apps/about/ai-expo-2026.jpg',
    alt: {
      ko: 'AI EXPO KOREA 2026에서 머신히어링을 소개하는 이수지 대표',
      en: 'CEO Suji Lee presenting Machine Hearing at AI EXPO KOREA 2026',
    },
    source:
      'https://www.linkedin.com/posts/deeplyinc_soundai-machinehearing-smartfactory-activity-7458031055225339905-Y3Bv',
  },
  legacyPhoto('sec_02_img_04.jpg'),
  {
    src: '/images/apps/about/mapo-office-2026.jpg',
    alt: {
      ko: '디플리 로고와 브랜드 색상으로 꾸민 새 사무실 입구',
      en: 'The new Deeply office entrance with its logo and brand colors',
    },
    source: anniversarySource,
  },
  legacyPhoto('sec_02_img_05.jpg'),
];

export const ABOUT_GALLERY_BOTTOM: readonly GalleryPhoto[] = [
  {
    src: '/images/apps/about/secon-2026.jpg',
    alt: {
      ko: 'SECON 2026 디플리 부스에서 Listen AI Safety를 시연하는 모습',
      en: 'Deeply demonstrating Listen AI Safety at SECON 2026',
    },
    source:
      'https://kr.linkedin.com/posts/deeplyinc_secon2026-listenai-soundai-activity-7440302235928043520-b7EO',
  },
  legacyPhoto('sec_02_img_07.jpg'),
  {
    src: '/images/apps/about/anniversary-celebration-2026.jpg',
    alt: {
      ko: '디플리 사무실에서 케이크와 함께 창립기념일을 축하하는 모습',
      en: 'Celebrating Deeply’s anniversary with a cake at the office',
    },
    source: anniversarySource,
    objectPosition: '50% 45%',
  },
  {
    src: '/images/apps/about/aw-2026-demo.jpg',
    alt: {
      ko: 'Automation World 2026에서 디플리 데모를 살펴보는 방문객들',
      en: 'Visitors exploring the Deeply demo at Automation World 2026',
    },
    source: automationWorldSource,
  },
  legacyPhoto('sec_02_img_09.jpg'),
  {
    src: '/images/apps/about/field-sound-inspection-2026.jpg',
    alt: {
      ko: '제조 현장에서 노트북으로 소리 검사 작업을 수행하는 디플리 팀원',
      en: 'A Deeply team member working on sound inspection at a manufacturing site',
    },
    source: fieldVisitSource,
    objectPosition: '50% 45%',
  },
  legacyPhoto('sec_02_img_10.jpg'),
  legacyPhoto('sec_02_img_11.jpg'),
];
